import { USER_PATH } from '@kurotetsu/share/apis/apiPaths';
import HttpExecutor, {
  DeleteMapping,
  GetMapping,
  PostMapping,
  PutMapping,
  RequestMapping
} from '@kurotetsu/share/decorator/IO';
import {
  AddAgentUserRequest,
  AddUserRequest,
  UpdateAgentUserRequest,
  UpdateUserRequest
} from '@kurotetsu/share/type/request/user';
import { UserInfoResponse } from '@kurotetsu/share/type/response/user';
import { UserType } from '@kurotetsu/share/constants';

@RequestMapping(USER_PATH)
export default class UserController extends HttpExecutor {
  @GetMapping()
  public async getUsers(_request: {
    userType: UserType;
  }): Promise<UserInfoResponse[]> {
    return super.defaultValue();
  }

  @GetMapping('/me/{userType}')
  public async getUserInfo(
    _userType: UserType,
    _request?: {
      stationId: string;
    }
  ): Promise<UserInfoResponse> {
    return super.defaultValue();
  }

  @GetMapping('/{userId}')
  public async getUserInfoByUserId(_userId: string): Promise<UserInfoResponse> {
    return super.defaultValue();
  }

  @PostMapping('/register')
  public async addFirebaseUserAndSetUserInfo(
    _body: AddUserRequest
  ): Promise<UserInfoResponse> {
    return super.defaultValue();
  }

  @PostMapping('/register')
  public async addUserAndSetUserInfo(
    _body: AddAgentUserRequest
  ): Promise<UserInfoResponse> {
    return super.defaultValue();
  }

  @PutMapping('/{userId}')
  public async updateUserInfo(
    _userId: string,
    _body: UpdateUserRequest | UpdateAgentUserRequest
  ): Promise<UserInfoResponse> {
    return super.defaultValue();
  }

  @DeleteMapping('/{userId}')
  public async deleteUserInfo(
    _userId: string,
    _query?: { version: number }
  ): Promise<UserInfoResponse> {
    return super.defaultValue();
  }

  @PostMapping('/password-reset/{userType}')
  public async resetPassword(
    _userType: UserType,
    _body: {
      email: string;
      resetPasswordUrl: string;
    }
  ): Promise<boolean> {
    return super.defaultValue();
  }
}
